import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    container: {
        lineHeight: '30px',
        marginBottom: '10px',
        paddingLeft: theme.spacing.unit * 2,
        textAlign: 'left',
    },
    domainText: {
        display: 'inline-block',
        paddingLeft: 4,
    },
    icon: {
        color: theme.palette.text['secondary'],
        fontSize: 10,
        marginBottom: 5
    },
    secondLine: {
        display: 'inline-block',
        marginBottom: theme.spacing.unit * 2,
        marginTop: -20,
    },
    textBlock: {
        display: 'inline-block'
    },
    titleIcon: {
        paddingRight: '6px',
        verticalAlign: '-webkit-baseline-middle'
    },
} );

const ProgressStatement = ( { stat, icon, isPercent, title, classes } ) => {
    const titleIcon = icon && <span className={classes.titleIcon}>{icon}</span>;

    return (
        <div className={classes.container}>
            { title &&
                ( <>
                    {titleIcon}
                    <Typography variant="overline" classes={{ root: classes.textBlock }}>
                        {title}
                    </Typography>
                    <br/>
                </> )
            }
            { ( Boolean( stat ) || stat === 0 ) &&
                ( <span className={classes.secondLine}>
                    <Typography variant="h4" classes={{ root: classes.textBlock }}> {stat} </Typography>
                    <Typography classes={{ root: classes.domainText }}> {'Domains'} </Typography>
                </span> )
            }
        </div>
    );
};

ProgressStatement.defaultProps = {
    isPercent: false,
    stat: null,
    title: null,
};

ProgressStatement.propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.object,
    isPercent: PropTypes.bool,
    stat: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
    title: PropTypes.string,
};

export default withStyles( styles )( ProgressStatement );
